import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '../store'

import { actionTypes } from './types'
import { TrackingEvent, TrackingPage } from './types/state'

type TrackingState = {
  enabled: boolean
  codeEmbedded: boolean
  lastPage?: TrackingPage
  lastEvent?: TrackingEvent
}

//
// Initial state
//

const initialState: TrackingState = {
  enabled: false,
  codeEmbedded: false,
}

//
// Slice (Actions & Reducers)
//

const slice = createSlice({
  name: 'tracking',
  initialState,
  reducers: {
    enableTracking: (state) => {
      state.enabled = true
    },
    disabledTracking: (state) => {
      state.enabled = false
    },
    setCodeEmbeded: (state) => {
      state.codeEmbedded = true
    },
    trackPage: (state, action: actionTypes.trackPage) => {
      state.lastPage = action.payload
    },
    trackEvent: (state, action: actionTypes.trackEvent) => {
      state.lastEvent = action.payload
    },
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state[slice.name]
const enabled = (state: RootState) => root(state).enabled
const codeEmbedded = (state: RootState) => root(state).codeEmbedded

export const selectors = {
  enabled,
  codeEmbedded,
}
